<template>
  <b-modal :id="modalId"
           title="Delete User">
    <p>Are you sure you want to delete user <strong>{{ user.name }}</strong>?</p>
    <template slot="modal-footer">
      <button type="button" class="btn btn-secondary" @click="hideModal">Cancel</button>
      <button type="button" class="mr-0 btn btn-danger"
              @click="promiseDeleteUser = handleDelete()"
              v-busy-button="promiseDeleteUser">Delete
      </button>
    </template>
  </b-modal>
</template>

<script>
  import userService from '@/services/amio-api/user.service'
  import notificationService from '@/services/notification/notification.service'

  export default {
    props: {
      modalId: {
        type: String,
        required: true
      },
      user: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        promiseDeleteUser: null
      }
    },

    methods: {
      hideModal() {
        this.promiseDeleteUser = null
        this.$root.$emit('bv::hide::modal', this.modalId)
      },

      handleDelete() {
        return userService.delete(this.user.id)
          .then(() => {
            this.$emit('userDeleted', this.user)
            notificationService.success('User was successfully deleted')
          })
          .catch(error => log.debug('could not delete user', error))
          .then(this.hideModal)
      }
    }
  }
</script>
